import React, {Component} from 'react'
import {Button} from "react-bootstrap";
import KoszykService from "../KoszykService";
import * as imgParagon from '../../img/kod-paragon.jpg'

export default class WczytajParagon extends Component {

    constructor(props) {
        super(props);

        this.state = {
            idBi: ''
        }

        this.onChangeIdBi = this.onChangeIdBi.bind(this)
    }

    componentDidMount() {
        if (this.props.idBi !== undefined && this.props.idBi !== null) {
            this.setState({idBi: this.props.idBi})
            this.checkTransactionId(this.props.idBi)
        }
    }

    onChangeIdBi(e) {
        this.setState({idBi: e.target.value})
    }

    checkTransactionId(idParagonu) {
        this.props.setButtonLoader(true)
        KoszykService.getPotwierdzeniePrzejazdu(idParagonu)
            .then((response) => {
                const file = new Blob(
                    [response.data],
                    {type: 'application/pdf'});
                const fileURL = URL.createObjectURL(file);
                let link = document.createElement('a');
                link.href = fileURL;
                link.setAttribute('download', 'Potwierdzenie-przejazdu-' + idParagonu + '.pdf');
                link.click();
                this.setState({idBi: ''})
                this.props.setBiletData(response.data)
                this.props.setIdValid(true)
                this.props.setIdSuccess(true)
                this.props.setIdBi(this.state.idBi)
                this.props.setButtonLoader(false)
            }).catch(e => {
            this.props.setIdValid(false)
            this.props.setButtonLoader(false)
        })
    }

    render() {
        return <div>
            <div className="row" style={{alignItems: 'center', width: '90%', margin: '0 auto'}}>
                <div className="col-12">
                    <div className="row">
                        <div className={'col-12'}>
                            <h2 className="text-center" style={{fontWeight: 'bold'}}>Potwierdzenie przejazdu</h2>
                        </div>
                        <div className="col-12">
                            <hr/>
                            <p style={{fontWeight: 'normal'}}>Wygenerowanie potwierdzenia przejazdu jest możliwe po
                                podaniu przez klienta
                                numeru paragonu otrzymanego podczas zakupu biletu u kierowcy.</p>
                            <div className={'text-center'}>
                                <img src={imgParagon} className={'img-fluid'}/>
                                <div className={'small'}>Przykładowy numer paragonu </div>
                            </div>
                            <hr/>
                        </div>
                        <div className="col-12">
                            Numer paragonu:
                            <input type="text" className="form-control" value={this.state.idBi}
                                   onChange={this.onChangeIdBi}/>
                            {!this.props.idValid ?
                                <div className="niepoprawneDaneWynajem">Niepoprawny numer paragonu.</div> : null}
                        </div>
                        <div className="col-12">
                            <div className="row" style={{paddingTop: '15px'}}>
                                <div className="col-12 text-right">
                                    {this.props.buttonLoader ?
                                        <span className="loaderDim"><i
                                            className="fa fa-spinner fa-pulse fa-fw"
                                            style={{
                                                marginTop: 5,
                                                marginRight: 5,
                                                color: '#58b13d'
                                            }}> </i></span> : null}<Button bsStyle='success' disabled={this.props.buttonLoader}
                                            onClick={() => {
                                                this.checkTransactionId(this.state.idBi)
                                            }}>Dalej</Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
}



// WEBPACK FOOTER //
// ./src/components/koszyk/potwierdzeniePrzejazduComponents/WczytajParagon.js